var React = require('react');

function SDCDownload18N (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M11.36006,7.4888,9.75,9.22288V1.11759a.5.5,0,0,0-.5-.5h-.5a.5.5,0,0,0-.5.5V9.22288L6.63994,7.4888a.5.5,0,0,0-.70654-.02628l-.3666.34023a.5.5,0,0,0-.02637.70662l.00011.00011,3.09308,3.33076a.5.5,0,0,0,.70662.02614l.02614-.02614,3.09308-3.33076a.5.5,0,0,0-.02615-.70662l-.00011-.00011-.3666-.34023A.5.5,0,0,0,11.36006,7.4888Z","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"M15.5,15H2.5a1.25,1.25,0,0,1-1.25-1.25V10.07227a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5V13.5h12.5V10.09766a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5V13.75A1.25,1.25,0,0,1,15.5,15Z","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCDownload18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCDownload18N;

SDCDownload18N.default = SDCDownload18N;
